var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from 'shared/components';
import useWindowDimensions from 'shared/hooks/useWindowDimensionsHook';
import { PowerPanelContent } from './powerPanelContent';
import { PowerPanelFooter } from './powerPanelFooter';
import { PowerPanelHeader } from './powerPanelHeader';
import { useViewAsContext } from 'shared/features/view-as';
import { usePowerPanelContext } from 'shared/features/power-panel';
export var PowerPanel = function () {
    var viewAsEnabled = useViewAsContext().viewAsEnabled;
    var height = useWindowDimensions().height;
    var panelBoxProps = usePowerPanelContext().panelBoxProps;
    var boxHeight = height;
    if (viewAsEnabled) {
        boxHeight = boxHeight - 60;
    }
    return (_jsx(Box, __assign({ width: "sm", top: 0, pos: "sticky", h: boxHeight.toString() + 'px', minHeight: boxHeight.toString() + 'px', flexGrow: 0, flexShrink: 0, borderLeftWidth: "1px", borderLeftColor: "gray.400" }, panelBoxProps, { children: _jsxs(Stack, __assign({ gap: 0, height: "100%", overflowY: "auto" }, { children: [_jsx(PowerPanelHeader, {}), _jsx(PowerPanelContent, {}), _jsx(PowerPanelFooter, {})] })) })));
};
